
import { defineComponent, ref } from 'vue'
import BaseForm from '@/base-ui/form'

export default defineComponent({
  components: {
    BaseForm
  },
  props: {
    formConfig: {
      type: Object,
      required: true
    }
  },
  emits: ['resetBtnClick', 'queryBtnClick'],
  setup(props, { emit }) {
    const originFormData: any = {}
    const formItems = props.formConfig?.formItems || []
    for (const item of formItems) {
      originFormData[`${item.field}`] = ''
    }

    const formData = ref(originFormData)

    // 用戶點擊重置
    const handleResetClick = () => {
      // 1.直接修改內部指針
      // for (const key in originFormData) {
      //   formData.value[key] = originFormData[key]
      // }
      formData.value = originFormData
      emit('resetBtnClick')
    }

    const handleSearchClick = () => {
      emit('queryBtnClick', formData.value)
    }

    return {
      formData,
      handleResetClick,
      handleSearchClick
    }
  }
})
